import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

/** Type guard for RTK Query FetchBaseQueryError. */
const isFetchBaseQueryError = (err: unknown): err is FetchBaseQueryError =>
	typeof err === "object" && err !== null && "status" in err;

export default isFetchBaseQueryError;
